import HelloWidget from "./HelloWidget";

export default HelloWidget;
